// extracted by mini-css-extract-plugin
export default {"main":"main_main__gh9YL","content":"main_content__Rw+T-"};